/**
 * Activate contact-form spam-guard tokens: copy the signed nonce into kdGuardJs
 * after a short delay so non-JS / instant bot POSTs fail server-side checks.
 */
export const initFormSpamGuard = () => {
	const activate = (form) => {
		const jsField = form.querySelector('.js-kd-guard-js');
		const nonceField = form.querySelector('input[name="kdGuardNonce"]');
		if (!jsField || !nonceField || jsField.dataset.kdGuardReady === '1') {
			return;
		}

		window.setTimeout(() => {
			jsField.value = nonceField.value;
			jsField.dataset.kdGuardReady = '1';
		}, 1500);
	};

	document.querySelectorAll('form').forEach((form) => {
		if (form.querySelector('.js-kd-guard-js')) {
			activate(form);
		}
	});

	// Exit-intent / late-injected forms.
	const observer = new MutationObserver((mutations) => {
		for (const mutation of mutations) {
			mutation.addedNodes.forEach((node) => {
				if (!(node instanceof HTMLElement)) {
					return;
				}
				if (node.matches?.('form') && node.querySelector('.js-kd-guard-js')) {
					activate(node);
				}
				node.querySelectorAll?.('form').forEach((form) => {
					if (form.querySelector('.js-kd-guard-js')) {
						activate(form);
					}
				});
			});
		}
	});

	observer.observe(document.documentElement, { childList: true, subtree: true });
};
